module.exports = __webpack_public_path__ + "img/2.cd69f411.png";